// Customizer
export const TOGGLE_COLLAPSED_NAV = 'toggle_collapse_menu'
export const DRAWER_TYPE = 'drawer_type'
export const FIXED_DRAWER = 'fixed_drawer'
export const COLLAPSED_DRAWER = 'collapsible'
export const MINI_DRAWER = 'mini_drawer'
export const THEME_COLOR = 'theme_color'
export const DARK_THEME = 'dark_theme'
export const WINDOW_WIDTH = 'window-width'
export const SWITCH_LANGUAGE = 'switch-language'
export const CHANGE_DIRECTION = 'change-direction'

export const CHANGE_NAVIGATION_STYLE = 'change-navigation-style'
export const HORIZONTAL_NAVIGATION = 'horizontal_navigation'
export const VERTICAL_NAVIGATION = 'vertical_navigation'

export const HORIZONTAL_MENU_POSITION = 'horizontal_menu_position'
export const ABOVE_THE_HEADER = 'above_the_header'
export const INSIDE_THE_HEADER = 'inside_the_header'
export const BELOW_THE_HEADER = 'below_the_header'

export const SWITCH_CONNECTION_STATUS = 'switch_connection_status'

// Auth
export const SIGNUP_USER = 'signup_user'
export const SIGNUP_USER_SUCCESS = 'signup_user_success'
export const SIGNIN_GOOGLE_USER = 'signin_google_user'
export const SIGNIN_GOOGLE_USER_SUCCESS = 'signin_google_user_success'
export const SIGNIN_FACEBOOK_USER = 'signin_facebook_user'
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'signin_facebook_user_success'
export const SIGNIN_TWITTER_USER = 'signin_twitter_user'
export const SIGNIN_TWITTER_USER_SUCCESS = 'signin_twitter_user_success'
export const SIGNIN_GITHUB_USER = 'signin_github_user'
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_SUCCESS'
export const SIGNIN_USER = 'signin_user'
export const SIGNIN_USER_SUCCESS = 'signin_user_success'
export const SIGNOUT_USER = 'signout_user'
export const SIGNOUT_USER_SUCCESS = 'signout_user_success'
export const INIT_URL = 'init_url'

// Template
export const FETCH_TEMPLATES = 'fetch_templates'
export const FETCH_TEMPLATES_SUCCESS = 'fetch_templates_success'
export const FETCH_CHANGE_ACTIVE_TEMPLATE_ID = 'fetch_change_active_template_id'
export const FETCH_CHANGE_ACTIVE_TEMPLATE_ID_SUCCESS = 'fetch_change_active_template_id_success'
export const FETCH_CREATE_TEMPLATE = 'fetch_create_template'
export const FETCH_CREATE_TEMPLATE_SUCCESS = 'fetch_create_template_success'

export const UPDATE_TEMPLATE_FIELDS = 'update_template_fields'
export const APPEND_TEMPLATE_FIELD_TO_LIST = 'append_template_field_to_list'
export const REMOVE_TEMPLATE_FIELD_FROM_LIST = 'remove_template_field_from_list'
export const EDIT_TEMPLATE_NAME = 'edit_template_name'
export const EDIT_TEMPLATE_FIELD_TYPE = 'edit_template_field_type'
export const SET_TEMPLATE_LIST_SHOW_STATUS = 'set_template_list_show_states'

export const FETCH_SAVE_TEMPLATE = 'fetch_save_template'
export const FETCH_SAVE_TEMPLATE_SUCCESS = 'fetch_save_template_success'
export const FETCH_DELETE_TEMPLATE = 'fetch_delete_template'
export const FETCH_DELETE_TEMPLATE_SUCCESS = 'fetch_delete_template_success'

// Notifications
export const CLOSE_SNACKBAR = 'close_snackbar'

// Script
export const FETCH_SCRIPT = 'fetch_script'
export const FETCH_SCRIPT_SUCCESS = 'fetch_script_success'
export const FETCH_CREATE_SCENE = 'fetch_create_scene'
export const FETCH_CREATE_SCENE_SUCCESS = 'fetch_create_scene_success'
export const FETCH_CREATE_SLATE = 'fetch_create_slate'
export const FETCH_CREATE_SLATE_SUCCESS = 'fetch_create_slate_success'
export const FETCH_CREATE_TAKE = 'fetch_create_take'
export const FETCH_CREATE_TAKE_SUCCESS = 'fetch_create_take_success'
export const UPDATE_SCENE = 'update_scene'
export const UPDATE_SLATE = 'update_slate'
export const UPDATE_TAKE = 'update_take'
export const FETCH_SAVE_SCENE = 'fetch_save_scene'
export const FETCH_SAVE_SCENE_SUCCESS = 'fetch_save_scene_success'
export const FETCH_SAVE_SLATE = 'fetch_save_slate'
export const FETCH_SAVE_SLATE_SUCCESS = 'fetch_save_slate_success'
export const FETCH_SAVE_TAKE = 'fetch_save_take'
export const FETCH_SAVE_TAKE_SUCCESS = 'fetch_save_take_success'
export const FETCH_DELETE_SCENE = 'fetch_delete_scene'
export const FETCH_DELETE_SCENE_SUCCESS = 'fetch_delete_scene_success'
export const FETCH_DELETE_SLATE = 'fetch_delete_slate'
export const FETCH_DELETE_SLATE_SUCCESS = 'fetch_delete_slate_success'
export const FETCH_DELETE_TAKE = 'fetch_delete_take'
export const FETCH_DELETE_TAKE_SUCCESS = 'fetch_delete_take_success'



// WEBPACK FOOTER //
// ./constants/ActionTypes.js